import { stripeCheckoutFormText } from './constants';

// Chooses the single sub-header line the shared Update-Credit-Card modal always renders below its
// header (TMS-2338 deliverable 6). Resume / past-due contexts get the copy that names resuming Power;
// a plain card update gets the default. Callers pass no free-text string — the context boolean selects.
export const getUpdateCcContextCopy = (isResume) => (
    isResume
        ? stripeCheckoutFormText.cc_update_context_resume
        : stripeCheckoutFormText.cc_update_context_default
);

export default getUpdateCcContextCopy;
